import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

import hc_lazyload from '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component'

export default class Home {
    constructor() {
        Home.strate_sejour()
        Home.strate_agenda()

        if (!Customer.ecoModeActive) {
            Home.strate_destination()
            Home.strate_social()
        }
    }

    static async strate_destination() {
        const swiperItem = '[data-swiper="destination"]'
        const slideItem = '[data-swiper="destination"] > *'

        const options = {
            slidesPerView: 1,
            speed: 1000,
            autoplay: {
                delay: 10000,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            on: {
                slideChange: (e) => {
                    update_slide(e.activeIndex)
                },
            },
        }

        $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')

        const swiperDestination = await Swiper.create(swiperItem, options)

        $('[data-trigger="destination"]').on('click', function () {
            swiperDestination.slideTo($(this).index())
        })

        function update_slide(index) {
            $('[data-item="destination"]').removeClass('is-active').eq(index).addClass('is-active')
            $('[data-trigger="destination"]')
                .removeClass('is-active')
                .eq(index)
                .addClass('is-active')
        }
    }

    static async strate_sejour() {
        const swiperItem = '[data-swiper="sejour"]'
        const slideItem = '[data-swiper="sejour"] > *'

        const options = {
            slidesPerView: 1,
            autoplay: {
                delay: 3000,
            },
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: false,
            on: {
                slideChange: (e) => {
                    update_slide(e.activeIndex)
                },
            },
        }

        $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')

        const swiperSejour = await Swiper.create(swiperItem, options)

        $('[data-trigger="sejour"]').on('mouseenter', function () {
            swiperSejour.slideTo($(this).parent().index())
        })

        function update_slide(index) {
            $('[data-item="sejour"]').removeClass('is-active').eq(index).addClass('is-active')
            $('[data-trigger="sejour"]').removeClass('is-active').eq(index).addClass('is-active')
        }
    }

    static strate_social() {
        if (
            $('[data-id="social-wall"]').length > 0 &&
            !$('[data-id="social-wall"]').is(':hidden')
        ) {
            import(
                '@wordpress/api-fetch' /* webpackChunkName: "scripts/wordpress_api_fetch" */
            ).then(({ default: apiFetch }) => {
                import('@wordpress/i18n' /* webpackChunkName: "scripts/wordpress_i18n" */).then(
                    ({ __ }) => {
                        apiFetch({
                            path: `${Customer.irisSsoInstagramUrl}?limit=6`,
                            method: 'post',
                        })
                            .then((result) => {
                                $('[data-id="social-wall"]').html(result.render)
                                $('body').addClass('has-social-wall')
                                hc_lazyload()
                            })
                            .catch((e) => {
                                $('[data-id="social-wall"]').html(
                                    __(
                                        'Désolé, une erreur est survenue pendant le chargement...',
                                        Customer.domain,
                                    ),
                                )
                            })
                    },
                )
            })
        }
    }

    static strate_agenda() {
        const trigger = $('[data-trigger="wpiris-filter-agenda"]')
        if (trigger.length > 0) {
            trigger.on('click', function () {
                $('#agendaPeriod').val($(this).attr('rel'))
                $('#agendaForm').submit()
            })
        }
    }
}
